var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    {
      ref: "dropdownMenu",
      staticClass: "v-dropdown",
      class: { right: _vm.align === "right", compact: _vm.compact },
    },
    [
      _vm._l(_vm.paths, function (path) {
        return _c("li", { key: path }, [
          _vm._v("\n    " + _vm._s(path) + "\n    "),
          _c(
            "svg",
            {
              staticStyle: { position: "absolute", top: "1px", right: "0" },
              attrs: { fill: "currentColor", viewBox: "0 0 24 24" },
            },
            [
              _c("path", {
                attrs: { d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" },
              }),
              _vm._v(" "),
              _c("path", { attrs: { d: "M0 0h24v24H0z", fill: "none" } }),
            ]
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "sub-menu v-dropdown" },
            _vm._l(_vm.optionsByPath("/" + path), function (option, index) {
              return _c("a-select-dropdown-item", {
                key: option[_vm.optionKey] + index,
                class: {
                  highlight: index === _vm.typeAheadPointer,
                  separator: option.separator,
                  paddedLarge: option.level,
                },
                attrs: {
                  isSelected: _vm.isSelected(option),
                  isAboveLevel: _vm.checkAboveLevel(option.level),
                  level: option.level || "",
                  cohort: _vm.cohort,
                  optionTitle: option[_vm.optionLabel],
                  multiple: _vm.multiple,
                },
                nativeOn: {
                  mousedown: function ($event) {
                    $event.preventDefault()
                    return _vm.select(option)
                  },
                },
              })
            }),
            1
          ),
        ])
      }),
      _vm._v(" "),
      _vm._l(_vm.optionsByPath("/"), function (option, index) {
        return _c("a-select-dropdown-item", {
          key: option[_vm.optionKey] + index,
          class: {
            highlight: index === _vm.typeAheadPointer,
            separator: option.separator,
            paddedLarge: option.level,
          },
          attrs: {
            isSelected: _vm.isSelected(option),
            isAboveLevel: _vm.checkAboveLevel(option.level),
            level: option.level || "",
            cohort: _vm.cohort,
            optionTitle: option[_vm.optionLabel],
            labelPrefix: option.labelPrefix,
            multiple: _vm.multiple,
          },
          nativeOn: {
            mousedown: function ($event) {
              $event.preventDefault()
              return _vm.select(option)
            },
          },
        })
      }),
      _vm._v(" "),
      !_vm.options || !_vm.options.length
        ? _c("li", { staticClass: "inactive" }, [
            _vm._v("No available options for the query"),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }